import { FC } from 'react';

// third-party
import { useSnackbar, ProviderContext , OptionsObject } from 'notistack';

// ==============================|| CUSTOM FUNCTION - NOTISTACK ||============================== //

interface IProps {
  setUseSnackbarRef: (showSnackbar: ProviderContext) => void;
}

const InnerSnackbarUtilsConfigurator: FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: ProviderContext;
const setUseSnackbarRef = (useSnackbarRefProp: ProviderContext) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />;
};

export default function toast(msg: string, options: OptionsObject = {}) {
  useSnackbarRef.enqueueSnackbar(msg, options);
}
